var _path, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgD3Js(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.9635 17.4701L23.9878 17.1541C23.9952 17.0284 16.4327 9.85327 16.4327 9.85327H16.2528C16.2528 9.85327 23.9181 17.9386 23.9644 17.4701H23.9635Z",
    fill: "url(#paint0_linear_46_13066)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.8283 14.9811L7.79801 15.0471L7.76519 15.1159C7.52417 15.6186 11.1401 19.1535 11.4309 18.7241L11.4706 18.6661L11.5144 18.6005C11.747 18.2474 7.93146 14.7524 7.82821 14.982L7.8283 14.9811Z",
    fill: "url(#paint1_linear_46_13066)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9381 19.9521C12.9288 19.9747 12.8552 20.0977 12.7887 20.1627C12.7774 20.1852 16.3186 23.6971 16.3186 23.6971H16.6374C16.6376 23.6971 13.3133 20.1006 12.9381 19.9521Z",
    fill: "url(#paint2_linear_46_13066)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9932 17.0904C23.8276 20.7617 20.7903 23.6973 17.0795 23.6973H16.5777L12.872 20.0464C13.1768 19.6165 13.4602 19.1711 13.7124 18.7067H17.0795C18.1443 18.7067 19.0109 17.8406 19.0109 16.7752C19.0109 15.7103 18.1443 14.8438 17.0795 14.8438H15.087C15.239 14.0412 15.3219 13.2138 15.3219 12.3671C15.3219 11.5076 15.2375 10.6683 15.0801 9.85294H16.3178L23.9705 17.3945C23.9796 17.2933 23.9869 17.1919 23.9924 17.0904H23.9932ZM2.01326 1H0V5.99054H2.01326C5.52951 5.99054 8.39058 8.85095 8.39058 12.3671C8.39113 13.293 8.18888 14.2077 7.79805 15.0471L11.4709 18.6672C12.7189 16.8036 13.3842 14.6109 13.3819 12.368C13.3819 6.09933 8.28179 1 2.01326 1Z",
    fill: "url(#paint3_linear_46_13066)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0795 1H8.927C10.9183 2.21572 12.567 3.93957 13.6906 5.99054H17.0796C18.1444 5.99054 19.0109 6.85663 19.0109 7.92202C19.0109 8.98741 18.1444 9.85322 17.0795 9.85322H16.3179L23.9707 17.3947C23.9887 17.1902 24 16.9843 24 16.7752C24 15.0928 23.3963 13.5495 22.3939 12.3484C23.3963 11.1477 24 9.60423 24 7.92202C24.0009 4.10538 20.8963 1 17.0795 1Z",
    fill: "url(#paint4_linear_46_13066)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5777 23.6973H8.98526C10.5136 22.7534 11.8348 21.5074 12.872 20.0464L16.5777 23.6973ZM11.4709 18.6662L7.79833 15.0461C6.78359 17.2266 4.57263 18.7433 2.01326 18.7433H0V23.7333H2.01326C5.95219 23.7333 9.43158 21.718 11.4709 18.6652V18.6662Z",
    fill: "url(#paint5_linear_46_13066)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_46_13066",
    x1: 829.391,
    y1: 153.541,
    x2: 2002.73,
    y2: 1405.15,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9A03C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7974E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_46_13066",
    x1: -73.089,
    y1: 198.156,
    x2: 470.072,
    y2: 728.034,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9A03C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7974E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_46_13066",
    x1: 185.122,
    y1: 384.976,
    x2: 670.995,
    y2: 942.029,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9A03C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7974E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_46_13066",
    x1: 696.02,
    y1: -99.0949,
    x2: 4772.17,
    y2: 5281.52,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F26D58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9A03C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_46_13066",
    x1: 1827.53,
    y1: 111.566,
    x2: 4493.41,
    y2: 1863.17,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B84E51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F68E48"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_46_13066",
    x1: 1376.8,
    y1: 1505.05,
    x2: 1416.36,
    y2: 2506.36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9A03C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7974E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgD3Js);
export default __webpack_public_path__ + "static/media/d3js.f880e1bff7925df69b0e0c1511f63831.svg";
export { ForwardRef as ReactComponent };